<template>
	<div class="register-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="register-content">
			<!-- Logo -->
			<div class="logo-container">
				<img src="../assets/logo.png" class="logo" />
			</div>
			<div class="msg-center-nav">
				<div class="msg-categories">
					<div v-for="category in categories" :key="category.key" class="category-item"
						:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
						{{ category.name }}
					</div>
				</div>
			</div>
			<!-- 登录表单 -->
			<form class="register-form">
				<!-- 手机号输入 -->
				<div class="form-group" v-if="loginType == 1">
					<div class="phone-input-container">
						<input type="tel" v-model="phone" placeholder="请输入手机号码" class="phone-input" />
						<span v-if="showAccountError" class="error-message">账号错误</span>
						<button type="button" @click="getVerificationCode" :disabled="countdown > 0"
							class="get-code-btn">{{countdown > 0 ? countdown + 's后重新获取': '获取验证码'}}</button>
					</div>
				</div>
				<!-- 验证码输入 -->
				<div class="form-group" v-if="loginType == 1">
					<div class="verification-container">
						<input type="text" v-model="verificationCode" placeholder="请输入验证码" class="verification-input" />
						<span v-if="showVerificationError" class="error-message">验证码错误</span>
					</div>
				</div>
				<!-- 手机号输入 -->
				<div class="form-group" v-if="loginType == 0">
					<div class="verification-container">
						<input type="text" v-model="phone" placeholder="请输入手机号" class="verification-input" />
						<span v-if="showAccountError" class="error-message">账号错误</span>
					</div>
				</div>
				<!-- 密码输入 -->
				<div class="form-group" v-if="loginType == 0">
					<div class="invite-container">
						<input :type="showOldPwd ? 'text' : 'password'" v-model="password" placeholder="请输入登录密码"
							class="invite-input" />
						<span v-if="showInviteError" class="error-message" style="margin-right: .2rem;">密码错误</span>
						<img class="showPwd" src="../assets/Personal/iconP.png" @click="showOldPwd = !showOldPwd"
							v-if="!showOldPwd" />
						<img class="showPwd" src="../assets/Personal/iconO.png" @click="showOldPwd = !showOldPwd"
							v-else />
					</div>
				</div>

				<!-- 服务协议 -->
				<div class="agreement-container">
					<label class="agreement-label">
						<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="agreeTerms" />
						<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else />
						<span class="agreement-text">我已阅读并同意</span>
						<div class="agreement-link" @click="userAgree = true">《岱屿画境AI创作平台用户服务协议》</div>
					</label>
				</div>

				<!-- 登录按钮 -->
				<button type="button" @click="login" class="register-btn">登录</button>

				<!-- 注册链接 -->
				<div class="login-link-container">
					还没有账号？
					<router-link :to="`${activeCategory == 'user' ? '/register' : '/creator-center'}`"
						class="login-link">马上注册</router-link>
				</div>
			</form>
			<div class="accountLoginMethod" v-if="loginType == 1" @click="changeLoginType(0)">
				账号登录
			</div>
			<div class="quickLoginMethod" v-if="loginType == 0">
				<div class="title">快捷登录方式</div>
				<div class="phoneCode" @click="changeLoginType(1)">
					<img class="phoneIcon" src="../assets/Register/phone.png" />
					手机号验证码登录
				</div>
			</div>
		</div>
		<div class="copyright">
			Copyright © 2025 岱屿画境 浙ICP备2025195505号 <img class="police" src="../assets/Register/police.png"
				alt="" />浙公网安备33010202005149号
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Register/abnormal.png')" :desc="'登录异常'" @clickOk="abnormalPop = false"
			v-if="abnormalPop" />
		<UserSeverAgreeDialog :show="userAgree" @close="userAgree = false" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import UserSeverAgreeDialog from '../components/UserSeverAgreeDialog.vue'
	export default {
		name: 'LoginPage',
		components: {
			PopToast,
			UserSeverAgreeDialog
		},
		data() {
			return {
				userAgree: false,
				loginType: 0, //0手机号密码，1手机号验证码
				password: '',
				phone: '',
				verificationCode: '',
				agreeTerms: true,
				showAccountError: false,
				showVerificationError: false,
				showInviteError: false,
				countdown: 0,
				abnormalPop: false,
				categories: [{
						key: 'user',
						name: '我是用户'
					},
					{
						key: 'creator',
						name: '我是创作者'
					}
				],
				showOldPwd: false,
				activeCategory: 'user',
			}
		},
		created() {
			if (this.$route.query.key) {
				this.activeCategory = this.$route.query.key
			}
		},
		methods: {
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				console.log(`切换到${category}分类`);
			},
			changeLoginType(type) {
				this.loginType = type
				this.showVerificationError = false
				this.showInviteError = false
				this.showInviteError = false
			},
			// 获取验证码
			getVerificationCode() {
				if (!this.phone) {
					return this.showAccountError = true
				} else {
					this.showAccountError = false

				}
				this.$api.post('/Other/phone_code', {
					phone: this.phone,
				}).then(res => {
					if (res.code == 1) {
						this.countdown = 60;
						// 倒计时
						const timer = setInterval(() => {
							this.countdown--;
							if (this.countdown <= 0) {
								clearInterval(timer);
							}
						}, 1000);
					} else {
						console.log(res.msg)
					}
					console.log(res)
				}).catch(err => {
					console.log(err);
				})
				// 模拟发送验证码
				console.log('发送验证码到:', this.phone);
			},

			// 注册
			login() {
				if (!this.phone) {
					return this.showAccountError = true
				} else {
					this.showAccountError = false
				}

				if (this.loginType == 0 && !this.password) {
					return this.showInviteError = true
				} else {
					this.showInviteError = false
				}

				if (this.loginType == 1 && !this.verificationCode) {
					return this.showVerificationError = true
				} else {
					this.showVerificationError = false
				}
				// // 表单验证
				// if (!this.password || !this.phone) {
				// 	alert('请填写必填项');
				// 	return;
				// }

				// if (!this.agreeTerms) {
				// 	alert('请阅读并同意服务协议');
				// 	return;
				// }

				// 模拟验证过程
				// 这里仅作演示，实际项目中应该调用API
				// this.showVerificationError = false;
				// this.showInviteError = false;

				// // 模拟验证码错误的情况
				// if (this.verificationCode !== '123456') {
				// 	this.showVerificationError = true;
				// 	return;
				// }

				// // 模拟邀请码错误的情况
				// if (this.inviteCode && this.inviteCode !== 'INVITE123') {
				// 	this.showInviteError = true;
				// 	return;
				// }

				if (this.loginType == 0) {
					this.$api.post('/Basics/login', {
						type: this.activeCategory == 'user' ? 1 : 2,
						user_login: this.phone,
						pwd: this.password,
					}).then(res => {
						if (res.code == 1) {
							this.showAccountError = false
							this.showInviteError = false
							localStorage.setItem('token', res.data)
							this.$api.post('/UserD/user_details', {}).then(result => {
								if (result.code == 1) {
									localStorage.setItem('userId', result.data.id)
									this.$store.dispatch('updateShopStatus', result.data.shop_status)
									this.$message.success(res.msg)
									if (this.activeCategory == 'user') {
										this.$router.replace('/')
									} else {
										this.$router.replace('/data-board')
									}
								} else {
									console.log(result.msg)
								}
							}).catch(err => {
								console.log(err);
							})
						} else {
							if (res.msg == '账号错误') {
								this.showAccountError = true
							} else if (res.msg == '账号异常') {
								this.abnormalPop = true
							} else if (res.msg == '当前审核未通过，无法登陆') {
								this.abnormalPop = true
							} else {
								this.showInviteError = true
							}
						}
						console.log(res)
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$api.post('/Basics/phone_login', {
						phone: this.phone,
						code: this.verificationCode,
						type: this.activeCategory == 'user' ? 1 : 2,
					}).then(res => {
						if (res.code == 1) {
							this.showVerificationError = false
							this.showAccountError = false
							localStorage.setItem('token', res.data)
							this.$api.post('/UserD/user_details', {}).then(result => {
								if (result.code == 1) {
									localStorage.setItem('userId', result.data.id)
									this.$store.dispatch('updateShopStatus', result.data.shop_status)
									this.$message.success(res.msg)
									if (this.activeCategory == 'user') {
										this.$router.replace('/')
									} else {
										this.$router.replace('/data-board')
									}
								} else {
									console.log(result.msg)
								}
							}).catch(err => {
								console.log(err);
							})
						} else {
							if (res.msg == '账号不存在') {
								this.showAccountError = true
							} else if (res.msg == '账号异常') {
								this.abnormalPop = true
							} else if (res.msg == '验证码错误') {
								this.showVerificationError = true
							} else if (res.msg == '当前审核未通过，无法登陆') {
								this.abnormalPop = true
							} else {
								this.showInviteError = true
							}
						}
						console.log(res)
					}).catch(err => {
						console.log(err);
					})
				}
				// 注册成功
				// console.log('注册成功:', {
				// 	nickname: this.nickname,
				// 	phone: this.phone,
				// 	email: this.email,
				// 	inviteCode: this.inviteCode
				// });

				// // 注册成功后跳转到首页
				// this.$router.push('/');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.register-container {
		width: 100%;
		height: 100vh;
		background: #FAEFDD;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.register-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 5.05rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		z-index: 1;
	}

	.logo-container {
		margin-top: 0.5rem;

		.logo {
			width: 1.5rem;
			height: .3rem;
		}
	}

	.msg-center-nav {
		margin-top: .2rem;
		width: 3.85rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid #EFEFEF;
	}

	.msg-categories {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.category-item {
		width: 1.72rem;
		font-weight: 400;
		font-size: .16rem;
		color: #C0C0C0;
		text-align: center;
		cursor: pointer;
		padding: .12rem 0;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #252525;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #252525;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #E29358;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	// 表单样式
	.register-form {
		width: 3.85rem;
		margin-top: .16rem;
	}

	.form-group {
		margin-top: .16rem;
	}

	.form-input {
		width: 100%;
		height: 0.44rem;
		border: .01rem solid #EFD8B8;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		outline: none;
		transition: border-color 0.3s ease;

		// &:focus {
		// 	border-color: #E29358;
		// }

		&::placeholder {
			color: #999999;
		}
	}

	// 手机号和验证码输入框样式
	.phone-input-container,
	.verification-container,
	.invite-container {
		width: 100%;
		height: 0.44rem;
		border: .01rem solid #EFD8B8;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		outline: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;

		.showPwd {
			position: absolute;
			top: calc(50% - .12rem);
			right: .1rem;
			width: .24rem;
			height: .24rem;
			cursor: pointer;
		}
	}

	.phone-input,
	.verification-input,
	.invite-input {
		width: 2.08rem;
		border: none;
		outline: none;
		padding: 0 0;

		font-size: 0.14rem;
		color: #333333;

		&::placeholder {
			color: #999999;
		}
	}

	.get-code-btn {
		padding: 0 0;
		color: #E29358;
		font-size: 0.14rem;
		cursor: pointer;

		&:disabled {
			background: #FFFFFF;
			color: #CCCCCC;
			border-color: #CCCCCC;
			cursor: not-allowed;
		}
	}

	// 错误提示样式
	.error-message {
		background: #F56C6C;
		padding: 0.04rem 0.09rem;
		border-radius: 0.02rem;
		font-weight: 400;
		font-size: 0.12rem;
		color: #FFFFFF;
	}

	// 服务协议样式
	.agreement-container {
		margin: 0.16rem 0 0;
		font-size: 0.14rem;
	}

	.agreement-label {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.agreement-checkbox {
		margin-right: 0.08rem;
		width: .16rem;
		height: .16rem;
		cursor: pointer;
	}

	.agreement-text {
		font-weight: 400;
		color: #333333;
		margin-right: 0.04rem;
	}

	.agreement-link {
		font-weight: 400;
		color: #E29358;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	// 按钮样式
	.register-btn {
		margin: .24rem auto 0;
		width: 3.85rem;
		height: 0.52rem;
		background: #E29358;
		padding: 0 0;
		border: none;
		border-radius: 0.04rem;
		font-size: 0.16rem;
		color: #252525;
		font-weight: 500;
		line-height: .52rem;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background: #D17F3A;
		}
	}

	// 注册链接样式
	.login-link-container {
		margin-top: .24rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #252525;
	}

	.login-link {
		font-weight: 400;
		color: #E29358;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	.accountLoginMethod {
		margin-top: .24rem;
		margin-bottom: .5rem;
		font-weight: 400;
		font-size: .14rem;
		color: #E29358;
		line-height: .2rem;
		cursor: pointer;
	}

	.quickLoginMethod {
		display: flex;
		flex-direction: column;
		align-items: center;

		.title {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #999999;
			line-height: .2rem;

			&::after {
				margin-left: .16rem;
				content: '';
				display: inline-block;
				width: 1.05rem;
				border: 0.01rem solid #EFD8B8;
			}

			&::before {
				margin-right: .16rem;
				content: '';
				display: inline-block;
				width: 1.05rem;
				border: 0.01rem solid #EFD8B8;
			}
		}

		.phoneCode {
			margin-top: .24rem;
			margin-bottom: .5rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #333333;
			cursor: pointer;

			.phoneIcon {
				width: .36rem;
				height: .36rem;
				margin-bottom: .1rem;
			}
		}
	}


	.copyright {
		position: fixed;
		bottom: .16rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: 400;
		font-size: .12rem;
		color: #333333;
		display: flex;
		align-items: center;

		.police {
			margin-left: .12rem;
			margin-right: .04rem;
			width: .14rem;
			height: .14rem;
		}
	}
</style>